

import {HttpClient, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {SERVER_API_URL} from '../../app.constants';
import {Observable} from 'rxjs/index';
import {map} from 'rxjs/internal/operators';
import {createRequestOption} from '../../shared/util/request-util';
import {IRapidCustomer, RapidCustomer} from '../../shared/model/rapid-customer.model';

type EntityResponseType = HttpResponse<IRapidCustomer>;
type EntityArrayResponseType = HttpResponse<IRapidCustomer[]>;

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({ providedIn: 'root' })
export class RapidCustomerService {
    public resourceUrl = SERVER_API_URL + 'api/rapidCustomers';

    constructor(protected http: HttpClient) {}

    create(rapidCustomer: IRapidCustomer): Observable<EntityResponseType> {
      // alert(' in create action date ==' + rapidCustomer.actionDate)
        const copy = this.convertDateFromClient(rapidCustomer);
      // alert(' in creat ecopy action date ==' + copy.actionDate)

      return this.http
            .post<IRapidCustomer>(this.resourceUrl, copy, { observe: 'response' })
            .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
    }

    update(rapidCustomer: IRapidCustomer): Observable<EntityResponseType> {
        const copy = this.convertDateFromClient(rapidCustomer);
        return this.http
            .put<IRapidCustomer>(this.resourceUrl, copy, { observe: 'response' })
            .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http
            .get<IRapidCustomer>(`${this.resourceUrl}/${id}`, { observe: 'response' })
            .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
    }

    // findWithCustomerId(id: number): Observable<EntityResponseType> {
    //     return this.http
    //         .get<IRapidCustomer>(`${this.resourceUrl + '-customer'}/${id}`, { observe: 'response' })
    //         .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
    // }

  findAllRapidCustomerWithCustomerId(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IRapidCustomer[]>(this.resourceUrl + '-customer', { params: options, observe: 'response' });
  }

  findAllRapidCustomerWithPrijectId(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IRapidCustomer[]>(this.resourceUrl + '-project', { params: options, observe: 'response' });
  }




  // findWithCustomerId(id: number): Observable<EntityArrayResponseType> {
  //   return this.http
  //     .get<IRapidCustomer[]>(`${this.resourceUrl + '-find'}/${id}`, { observe: 'response' })
  //     .pipe(map((res: EntityArrayResponseType) => this.convertDateFromServer(res)));
  // }

  // findMyRapidCustomer(id: number): Observable<EntityArrayResponseType> {
  //   return this.http
  //     .get<IRapidCustomer[]>(`${this.resourceUrl}`, { observe: 'response' })
  //     .pipe(map((res: EntityArrayResponseType) => this.convertDateFromServer(res)));
  // }

    // query(req?: any): Observable<EntityArrayResponseType> {
    //     const options = createRequestOption(req);
    //     return this.http
    //         .get<IRapidCustomer[]>(this.resourceUrl, { params: options, observe: 'response' })
    //         .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
    // }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IRapidCustomer[]>(this.resourceUrl, {params: options, observe: 'response'});
  }
  findMyRapidCustomerCount(id: number): Observable<HttpResponse<any>> {
        // const options = createRequestOption(req);
        return this.http
            .get<any>(`${this.resourceUrl + '-self-count'}/${id}`, {  observe: 'response' });

    // return this.http.get<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });

  }

  findMyRapidCustomer(id: number): Observable<EntityArrayResponseType> {
        // const options = createRequestOption(req);
        return this.http
            .get<IRapidCustomer[]>(`${this.resourceUrl + '-self'}/${id}`, {  observe: 'response' })
            .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
    }


  getRapidCustomerNotification(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IRapidCustomer[]>(this.resourceUrl + '-notifications', {params: options, observe: 'response'});
  }

  findTodayRapidCustomer(id: number): Observable<EntityArrayResponseType> {
        // const options = createRequestOption(req);
        return this.http
            .get<IRapidCustomer[]>(`${this.resourceUrl + '-today'}/${id}`, {  observe: 'response' })
            .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
    }

  findWithCustomerId(id: number, req?: any): Observable<EntityArrayResponseType> {
        // const options = createRequestOption(req);
    const options = createRequestOption(req);
    return this.http.get<IRapidCustomer[]>(`${this.resourceUrl + '-find'}/${id}`, {params: options, observe: 'response'});

    // return this.http
    //         .get<IRapidCustomer[]>(`${this.resourceUrl + '-find'}/${id}`, {  observe: 'response' })
    //         .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
    }

  findActionRapidCustomersWithCustomerId(id: number): Observable<EntityArrayResponseType> {
        // const options = createRequestOption(req);
        return this.http
            .get<IRapidCustomer[]>(`${this.resourceUrl + '-action-find'}/${id}`, {  observe: 'response' })
            .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
    }

  findFollowRapidCustomersWithCustomerId(id: number): Observable<EntityArrayResponseType> {
        // const options = createRequestOption(req);
        return this.http
            .get<IRapidCustomer[]>(`${this.resourceUrl + '-follow-find'}/${id}`, {  observe: 'response' })
            .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    protected convertDateFromClient(rapidCustomer: IRapidCustomer): IRapidCustomer {
        const copy: IRapidCustomer = Object.assign({}, rapidCustomer, {
            // expiratioDate:
            //     rapidCustomer.expiratioDate != null && rapidCustomer.expiratioDate.isValid()
            //         ? rapidCustomer.expiratioDate.format(DATE_FORMAT)
            //         : null,
            // actionDate:
            //     rapidCustomer.actionDate != null && rapidCustomer.actionDate.isValid() ? rapidCustomer.actionDate.format(DATE_FORMAT) : null,
            // followupbyDate:
            //     rapidCustomer.followupbyDate != null && rapidCustomer.followupbyDate.isValid()
            //         ? rapidCustomer.followupbyDate.format(DATE_FORMAT)
            //         : null,
          // createdDate:
          //       rapidCustomer.createdDate != null && rapidCustomer.createdDate.isValid() ? rapidCustomer.createdDate.format(DATE_TIME_FORMAT) : null
        });
        return copy;
    }

    protected convertDateFromServer(res: EntityResponseType): EntityResponseType {
        if (res.body) {
            // res.body.expiratioDate = res.body.expiratioDate != null ? moment(res.body.expiratioDate) : null;
            // res.body.actionDate = res.body.actionDate != null ? moment(res.body.actionDate) : null;
            // res.body.followupbyDate = res.body.followupbyDate != null ? moment(res.body.followupbyDate) : null;
            // res.body.createdDate = res.body.createdDate != null ? moment(res.body.createdDate) : null;
        }
        return res;
    }

    protected convertDateArrayFromServer(res: EntityArrayResponseType): EntityArrayResponseType {
        if (res.body) {
            res.body.forEach((rapidCustomer: IRapidCustomer) => {
                // rapidCustomer.expiratioDate = rapidCustomer.expiratioDate != null ? moment(rapidCustomer.expiratioDate) : null;
                // rapidCustomer.actionDate = rapidCustomer.actionDate != null ? moment(rapidCustomer.actionDate) : null;
                // rapidCustomer.followupbyDate = rapidCustomer.followupbyDate != null ? moment(rapidCustomer.followupbyDate) : null;
                // rapidCustomer.createDate = rapidCustomer.createDate != null ? moment(rapidCustomer.createDate) : null;
            });
        }
        return res;
    }



  search(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IRapidCustomer[]>(this.resourceUrl + '-search', {params: options, observe: 'response'});
  }

  searchReport(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IRapidCustomer[]>(this.resourceUrl + '-search-report', {params: options, observe: 'response'});
  }

  searchLastReport(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IRapidCustomer[]>(this.resourceUrl + '-search-report-last', {params: options, observe: 'response'});
  }


  public exportAsExcelFile(json: any[], excelFileName: string): void {
  //   // alert(' json == ' + json.length);
  //   const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
  //   const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
  //   const excelBuffer: any = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
  //   this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  public exportAsExcelFile2(json: RapidCustomer[], excelFileName: string): void {
  //   // alert(' json == ' + json.length);
  //   const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
  //   const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
  //   const excelBuffer: any = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
  //   this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
  //   const data: Blob = new Blob([buffer], {
  //     type: EXCEL_TYPE
  //   });
  //   FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

}
